import { createGlobalStyle } from 'styled-components';
import { typography } from '@awesomecomponents/mux';
import { BREAKPOINTS } from '@awesomecomponents/mux/core/spacing';

/**
 * Styled components v4 + uses a styled component to represent root style.
 * Imported as a childless component at top of render tree.
 */
const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
    box-sizing: border-box;
  }
  body {
    position: relative;
    margin: 0;
    min-height: 100%;
    font-family: ${typography.fontFamily};
    font-size: ${typography.fontSize};
    font-weight: 400;
  }
  /*==============Media Queries==============*/
  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    body {
      padding-bottom: 0;
    }
  }
`;
export default GlobalStyle;
